import { render, staticRenderFns } from "./InterestPlaceModal.vue?vue&type=template&id=58900ec4"
import script from "./InterestPlaceModal.vue?vue&type=script&lang=js"
export * from "./InterestPlaceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports